module.exports = __webpack_public_path__ + "img/abacus_type_7.5d29ed5b.png";